import { RELEASE_CATALOG } from './releases';
import { getVisibleGuides } from '../product-guides/visibility';

const LAST_SEEN_STORAGE_KEY = 'company_product_releases_last_seen_at';

const contentModules = import.meta.glob('./content/*.md', {
  query: '?raw',
  import: 'default',
  eager: true,
});

function slugFromContentPath(path) {
  return path.replace(/^\.\/content\//, '').replace(/\.md$/, '');
}

const contentBySlug = Object.fromEntries(
  Object.entries(contentModules).map(([path, raw]) => [slugFromContentPath(path), raw])
);

function sortByPublishedAtDesc(releases) {
  return [...releases].sort(
    (a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime()
  );
}

export function getProductReleases() {
  return sortByPublishedAtDesc(
    RELEASE_CATALOG.filter((entry) => contentBySlug[entry.slug]).map((entry) => ({
      ...entry,
      content: contentBySlug[entry.slug],
    }))
  );
}

export function getProductReleaseBySlug(slug) {
  const meta = RELEASE_CATALOG.find((entry) => entry.slug === slug);
  if (!meta) {
    return null;
  }
  const content = contentBySlug[slug];
  if (!content) {
    return null;
  }
  return { ...meta, content };
}

// Aggiornamenti e guide insieme: il megafono li conta con la loro data di pubblicazione.
// Le guide entrano solo se l'utente può aprirle.
export function getNewsFeed(user) {
  return sortByPublishedAtDesc([
    ...getProductReleases().map((release) => ({ ...release, kind: 'update' })),
    ...getVisibleGuides(user).map((guide) => ({
      kind: 'guide',
      slug: guide.slug,
      title: guide.title,
      summary: guide.tile,
      publishedAt: guide.publishedAt,
    })),
  ]);
}

export function getLatestPublishedAt(user) {
  const feed = getNewsFeed(user);
  if (!feed.length) {
    return null;
  }
  return feed[0].publishedAt;
}

export function getUnreadReleaseCount(lastSeenAt, user) {
  if (!lastSeenAt) {
    return getNewsFeed(user).length;
  }
  const lastSeen = new Date(lastSeenAt).getTime();
  return getNewsFeed(user).filter(
    (release) => new Date(release.publishedAt).getTime() > lastSeen
  ).length;
}

export function getLastSeenStorageKey() {
  return LAST_SEEN_STORAGE_KEY;
}

export function markProductReleasesAsSeen(user) {
  const latest = getLatestPublishedAt(user);
  if (!latest) {
    return;
  }
  localStorage.setItem(LAST_SEEN_STORAGE_KEY, latest);
}

export function getProductReleasesLastSeenAt() {
  return localStorage.getItem(LAST_SEEN_STORAGE_KEY);
}
